import { Component, OnInit } from '@angular/core';
import { AnimationOptions } from 'ngx-lottie';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html'
})
export class LoaderComponent implements OnInit {
  options: AnimationOptions = {
    path: './assets/data/lottie.json',
  };

  constructor() {}

  ngOnInit() {}
}
